"use client";

import { useEffect, useState } from "react";

import { SolidIcons } from "@/components/icons";
import { cn } from "@/lib/utils";

const socialIconStyles = "size-6 transition-colors hover:text-grey-200";

export function ArticleShareRail({
  title,
  className,
}: {
  title: string;
  className?: string;
}) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);

  const links = [
    {
      label: "Share on X",
      href: `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
      Icon: SolidIcons.X,
      external: true,
    },
    {
      label: "Share on LinkedIn",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`,
      Icon: SolidIcons.Linkedin,
      external: true,
    },
    {
      label: "Share on Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
      Icon: SolidIcons.Facebook,
      external: true,
    },
    {
      label: "Share by email",
      href: `mailto:?subject=${t}&body=${u}`,
      Icon: SolidIcons.Envelope,
      external: false,
    },
  ];

  return (
    <div className={cn("text-grey-400 flex flex-col gap-5", className)}>
      {links.map(({ label, href, Icon, external }) => (
        <a
          key={label}
          href={href}
          aria-label={label}
          {...(external
            ? { target: "_blank", rel: "noopener noreferrer" }
            : {})}
        >
          <span className="sr-only">{label}</span>
          <Icon className={socialIconStyles} />
        </a>
      ))}
    </div>
  );
}
